import React from 'react'
import { Button, Card, DatePicker, Flex, Input, Tag, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'

const { Text, Link } = Typography
const { RangePicker } = DatePicker
const { Search } = Input
const textStyle = { marginBottom: '10px' }
const columnStyle = {
  width: '50%',
  textAlign: 'left',
  wordBreak: 'break-word', wordWrap: 'break-word',
}
const LabReqCard = (props) => {
  const { lab, chatID } = props
  const labNumber = lab.labCenterDetails?.phoneNumber || 'N/A'
  const navigate = useNavigate()

  const handleViewDetailsClick = () => {
    navigate(`/labtracking/${chatID}`)
  }
  const handleViewSOAPNotes = () => {
    navigate(`/soapnotes/${chatID}`)
  }
  const handleViewResults = () => {
    navigate(`/viewresults/${chatID}`)
  }
  const handleViewUpdates = () => {
    navigate(`/viewupdates/${chatID}`)
  }
  const getTagColor = (status) => {
    let color
    switch (status) {
      case 'critical':
        color = 'red'
        break
      case 'normal':
        color = 'green'
        break
      case 'abnormal':
        color = 'yellow'
        break
      case 'undetermined':
        color = 'grey'
        break
      case 'pending':
        color = 'orange'
        break
      case 'awaiting':
        color = 'purple'
        break
      default:
        color = 'blue'
    }
    return color
  }

  return (

    <Card size="medium">
      <Flex justify="space-between">
        <Text strong style={{ ...textStyle, ...columnStyle }}>Patient name:</Text>
        <Text style={columnStyle}>{lab.patientName}</Text>
      </Flex>
      <Flex justify="space-between">
        <Text strong style={{ ...textStyle, ...columnStyle }}>Date of encounter:</Text>
        <Text style={columnStyle}>{new Date(lab.timestamp).toLocaleString()}</Text>
      </Flex>
      <Flex justify="space-between">

        <Text strong style={{ ...textStyle, ...columnStyle }}>Status:</Text>
        <div style={{ ...textStyle, ...columnStyle }}>
          <Tag
            color={getTagColor(lab.status)}>{lab.status}
          </Tag>
        </div>

      </Flex>
      <Flex justify="space-between">
        <Text strong style={{ ...textStyle, ...columnStyle }}>Diagnosis:</Text>
        <Text style={columnStyle}>{lab?.assessment || 'N/A'}</Text>
      </Flex>
      <Flex justify="space-between">
        <Text strong style={{ ...textStyle, ...columnStyle }}>Results</Text>
        {lab?.results ? (
          <Link style={columnStyle} onClick={handleViewResults} target="_blank">
            View Results
          </Link>
        ) : (
          <Link style={columnStyle}>N/A</Link>
        )}
      </Flex>
      <Flex justify="space-between">
        <Text strong style={{ ...textStyle, ...columnStyle }}>Updates</Text>
        {lab?.results ? (
          <Link style={columnStyle} onClick={handleViewUpdates} target="_blank">
            View Updates
          </Link>
        ) : (
          <Link style={columnStyle}>N/A</Link>
        )}
      </Flex>
      {/*  <Flex justify="space-between">
        <Text strong style={{ ...textStyle, ...columnStyle }}>SOAP Notes</Text>
        <Link style={columnStyle} onClick={handleViewSOAPNotes} target="_blank">
          View SOAP Notes
        </Link>
      </Flex>*/}
      <Flex justify="center" gap="small">
        <Button type="primary" size="small" onClick={handleViewDetailsClick} shape="round">
          View Details
        </Button>
      </Flex>
    </Card>

  )
}

export default LabReqCard
